import { TAB_IDS } from './tabIds';
export { TAB_IDS, };
